export default __webpack_public_path__ + "static/media/SML.df50f7e3.jpg";